import type { Shipment } from '@xbcb/api-gateway-client';
import { ModeOfTransport } from '@xbcb/shared-types';

export const usIsfEvaluator = (shipment: Shipment): boolean => {
  // ISF is only allowed when MOT === OCEAN
  return shipment?.legs?.[0]?.modeOfTransport === ModeOfTransport.OCEAN;
};
